module.exports = __webpack_public_path__ + "static/media/Vault_720p.6b0fee5a.mp4";